import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'
import { createJob } from 'store/Recruitment/actions'
import { setCreateJobSlide } from 'store/Recruitment/actions'

function Footer() {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const { createJobSlide, jobProps } = useSelector((store) => store.recruitment)

  const existingJob = jobProps?.find((el) => el?.name === 'id')

  console.log(existingJob ? existingJob.value : null, 'leart20')

  return (
    <div className='d-flex mx-5 mb-5'>
      {createJobSlide > 0 && (
        <button
          onClick={() => dispatch(setCreateJobSlide(createJobSlide - 1))}
          className='btn btn-outline-info'
        >
          <FontAwesomeIcon icon={faArrowLeft} className='mr-2' /> Previous
        </button>
      )}
      {createJobSlide !== 2 ? (
        <button
          onClick={() => dispatch(setCreateJobSlide(createJobSlide + 1))}
          className='btn btn-info ml-auto'
        >
          Next <FontAwesomeIcon icon={faArrowRight} className='ml-2' />
        </button>
      ) : (
        <div className='d-flex align-items-center ml-auto'>
          <button
            onClick={() => history.push('/jobs')}
            className='btn btn-secondary'
          >
            Cancel
          </button>
          <button
            onClick={() =>
              dispatch(
                createJob(
                  () => history.push('/jobs'),
                  existingJob ? existingJob.value : null
                )
              )
            }
            className='btn btn-info'
          >
            {location.pathname !== '/job/edit' ? 'Create' : 'Update'}
          </button>
        </div>
      )}
    </div>
  )
}

export default Footer
